<!-- eslint-disable -->
<template lang="pug">
    cs-modal.crop-image-modal(@close="$emit('close')", :is-blur="true")
        div(id="cropPlace")
        .modal__button(slot="footer")
            cs-button(
                color="blue"
                @click="cropImage"
            ) {{ $i18n.t('common.common_button_done') }}
</template>

<script>
    import Croppie from 'croppie';
    import CsModal from '../CsModal.vue';

    export default {
        name: 'CropImageModal',
        components: { CsModal },
        status: 'ready',
        release: '1.0.0',
        props: {
            /**
             * Image to crop.
             */
            image: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                cropEngine: null,
            };
        },
        mounted() {
            this.initCrop();
        },
        methods: {
            initCrop() {
                this.cropEngine = new Croppie(document.getElementById('cropPlace'), {
                    viewport: { width: 250, height: 250, type: 'circle' },
                    boundary: { width: 260, height: 260 },
                    showZoomer: true,
                    enableExif: true,
                });
                this.cropEngine.bind({
                    url: this.image,
                });
            },
            cropImage() {
                this.cropEngine.result('base64').then(result => {
                    this.$emit('cropImage', result);
                });
            },
        },
    };
</script>

<style lang="scss">
    .modal__button {
        display: flex;
        justify-content: center;
    }

    @mixin slider-mixin {
        border: none;
        height: 16px;
        width: 16px;
        border-radius: $border-radius-circle;
        background: $hsl-color-green-58;
    }

    .croppie-container,
    .cr-boundary {
        width: 100%;
        height: 100%;
    }

    .cr-boundary {
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        z-index: 1;
    }

    .cr-viewport {
        position: absolute;
        border: 1px solid $x-color-white;
        margin: auto;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        box-shadow: 0 0 2000px 2000px rgba($x-color-black, $opacity-disabled);
        z-index: 0;
    }

    .cr-original-image {
        display: none;
    }

    .cr-vp-circle {
        border-radius: $border-radius-circle;
    }

    .cr-overlay {
        z-index: 1;
        position: absolute;
        cursor: move;
    }

    .cr-slider-wrap {
        width: 100%;
        margin: $space-base auto;
        text-align: center;
    }

    .croppie-result {
        position: relative;
        overflow: hidden;

        img {
            position: absolute;
        }
    }

    .cr-image {
        max-width: none;
    }

    .cr-image,
    .cr-overlay,
    .cr-viewport {
        transform: translateZ(0);
    }

    .cr-slider {
        appearance: none;
        width: 300px;
        max-width: 100%;

        &::-webkit-slider-runnable-track {
            width: 100%;
            height: $space-xx-small;
            background: rgba($hsl-color-gray-92, $opacity-disabled);
            border: 0;
            border-radius: $border-radius-3;
        }

        &::-webkit-slider-thumb {
            appearance: none;
            @include slider-mixin;
            margin-top: -$space-x-small;
        }

        &::-moz-range-thumb {
            @include slider-mixin;
            margin-top: -$space-x-small;
        }

        &:focus {
            outline: none;
        }

        &::-moz-range-track {
            width: 100%;
            background: rgba($hsl-color-gray-92, $opacity-disabled);
            border: 0;
            border-radius: $border-radius-3;
        }

        &:-moz-focusring {
            outline: 1px solid $x-color-white;
            outline-offset: -1px;
        }

        &::-ms-track {
            width: 100%;
            background: transparent;
            border-color: transparent;
            color: transparent;
        }

        &::-ms-thumb {
            @include slider-mixin;
        }

        &::-ms-fill-lower,
        &::-ms-fill-upper {
            background: rgba($hsl-color-gray-92, $opacity-disabled);
            border-radius: $border-radius-6;
        }

        &:focus::-ms-fill-lower,
        &:focus::-ms-fill-upper {
            background: rgba($hsl-color-gray-92, $opacity-disabled);
        }
    }
</style>
